<template>
  <el-dialog custom-class="invoice-edit" title="编辑开票结果" width="540px" :close-on-click-modal="false" :visible.sync="visible">
    <el-alert :title="warnMsg" type="warning" show-icon> </el-alert>
    <el-form class="invoice-form" ref="form" label-width="100px" size="small" :model="form" :rules="rules">
      <el-form-item label="物流单号" prop="trickNo">
        <el-input placeholder="请输入物流单号" style="width: calc(100% - 70px)" :maxlength="30" v-model.trim="form.trickNo"></el-input>
        <el-button type="text" style="margin-left: 10px" @click="goToLink">查看物流</el-button>
      </el-form-item>
      <el-form-item label="备注" prop="trickRemark">
        <el-input placeholder="请填写备注，最多不超过100字" v-model.trim="form.trickRemark"></el-input>
      </el-form-item>
      <el-form-item label="发票" prop="invoiceFileIds">
        <el-upload
          ref="uploadRef"
          action="/paywages/api/file/upload"
          list-type="picture-card"
          :multiple="true"
          :on-remove="handleRemove"
          :http-request="handleUpload"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'invoiceEdit',
  data() {
    return {
      visible: false,
      warnMsg: '支持图片、PDF及OFD格式，最多上传10张，单张不超过10M',
      form: {
        invoiceId: '',
        trickNo: '',
        trickRemark: '',
        invoiceFileIds: [],
      },
      rules: {
        trickNo: [{ required: true, message: '请输入物流单号', trigger: 'blur' }],
        invoiceFileIds: [{ required: true, message: '请上传发票文件', trigger: 'blur' }],
      },

      fileList: [],
    };
  },
  methods: {
    show(invoice) {
      this.form.invoiceId = invoice.invoiceApplyId;
      this.form.trickNo = invoice.trickNo;
      this.form.trickRemark = invoice.trickRemark;
      this.visible = true;
    },
    close() {
      this.$refs.uploadRef.clearFiles();
      this.$refs.form.resetFields();
      this.visible = false;
    },
    goToLink() {
      if (this.form.trickNo.trim()) {
        window.open(`https://www.baidu.com/s?wd=${this.form.trickNo}`);
      }
    },
    handleRemove(file) {
      // eslint-disable-next-line arrow-parens
      const findIndex = this.fileList.findIndex((item) => item === file.uid);
      if (findIndex > -1) {
        this.form.invoiceFileIds.splice(findIndex, 1);
      }
    },
    handleUpload(params) {
      const formData = new FormData();
      formData.append('file', params.file);
      formData.append('fileName', params.file.name);

      api
        .uploadTick({
          params: {
            data: formData,
          },
        })
        .then((res) => {
          const fileId = res;
          this.form.invoiceFileIds.push(fileId);
          this.fileList.push(params.file.uid);
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    handleCancel() {
      this.close();
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.invoice-edit {
  .invoice-form {
    margin-top: 10px;
  }
  /deep/.el-dialog__body {
    padding: 0px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/components/invoiceEdit.vue